'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLiveTv = function MdLiveTv(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 16.6l11.6 6.8-11.6 6.6v-13.4z m20 16.8v-20h-30v20h30z m0-23.4c1.8 0 3.4 1.5 3.4 3.4v20c0 1.8-1.6 3.2-3.4 3.2h-30c-1.8 0-3.4-1.4-3.4-3.2v-20c0-1.9 1.6-3.4 3.4-3.4h12.7l-5.5-5.5 1.2-1.1 6.6 6.6 6.6-6.6 1.2 1.1-5.5 5.5h12.7z' })
        )
    );
};

exports.default = MdLiveTv;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/live-tv.js
// module id = 898
// module chunks = 0